export class WishList {
    userKey: number;
    offerKey: number[];

    constructor(userKey: number, offerKey: number[]) {
        this.userKey = userKey;
        this.offerKey = offerKey;
    }
}
